module.exports = __webpack_public_path__ + "static/media/miniplus.31a28622.svg";